export default __webpack_public_path__ + "static/media/tracking.c6eb3bf3.png";